
export default {
  props: {
    theme: { type: String, default: 'default' },
    loading: { type: Boolean, default: false },
  }
}
